/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectLabel/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaSelectLabel({
  children,
  viewPath = "/DesignSystem/TysiaSelect/TysiaSelectLabel",
  text,
  marginRight = 0,
  marginBottom = 4,
  size,
  required
  
}) {
let dtTysiaselectlabelColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaSelectLabel.color.primary.base'
        })
let dtColorsRed600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.600'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaSelectLabel.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text={text}
 color={dtTysiaselectlabelColorPrimaryBase}
 size="normal"
 weight="medium"
 whiteSpace="nowrap"
 textOverflow="ellipsis"
 marginRight={marginRight}
 marginBottom={size === "small" ? marginBottom : marginBottom}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="*"
 marginLeft="2px"
 color={dtColorsRed600}
 opacity={required ? 1 : 0}
/>
</div>
{children}
</React.Fragment>)
}